import { removeImageManifestEntries, AppDispatch, RootState } from "utils/store";
import { countImageIdReferences } from "utils/templates/image-manifest";
import { deletePhoto } from "./deletePhoto";

/**
 * Call this BEFORE clearing a node's own `imageId` attr, while the reference about to be removed
 * still counts — a count of exactly 1 at that point means it's the last one. If another node still
 * references the same manifest id (e.g. because a page/section was duplicated), this no-ops: the
 * blob and manifest entry stay, since the other node still needs them.
 */
export const removeImageIfOrphaned = (imageId: string) => {
  return async (dispatch: AppDispatch, getState: () => RootState) => {
    const { pages, imageManifest } = getState().templateBuilderSlice;

    const refs = countImageIdReferences(pages).get(imageId) ?? 0;
    if (refs > 1) return;

    const entry = imageManifest.find((e) => e.id === imageId);
    if (!entry) return;

    dispatch(removeImageManifestEntries([imageId]));
    await deletePhoto(entry.docId);
  };
};
